export default class DeleteSeguimientoResultadoC3 {
  #repository

  constructor(repository) {
    this.#repository = repository
  }

  async execute(idPersonal, idResultado, idSeguimiento) {
    await this.#repository.delete(idPersonal, idResultado, idSeguimiento)
  }
}
